import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PanicManualEventModels } from '@share-models';
import { api } from '../consts/url';

@Injectable({ providedIn: 'root' })
export class ManualEventsService {
  private readonly http = inject(HttpClient);

  public getAll(
    filter: PanicManualEventModels.QueryFilter = {},
  ): Observable<PanicManualEventModels.Document[]> {
    const params: Record<string, string> = {};
    if (filter.lastId) {
      params['lastId'] = filter.lastId;
    }
    if (filter.search) {
      params['search'] = filter.search;
    }
    return this.http.get<PanicManualEventModels.Document[]>(
      api.manualEvents.all,
      { params },
    );
  }

  public create(
    dto: PanicManualEventModels.CreateDto,
  ): Observable<PanicManualEventModels.Document> {
    return this.http.post<PanicManualEventModels.Document>(
      api.manualEvents.create,
      dto,
    );
  }

  public update(
    id: string,
    dto: PanicManualEventModels.UpdateDto,
  ): Observable<boolean> {
    return this.http.put<boolean>(api.manualEvents.update(id), dto);
  }

  public delete(id: string): Observable<PanicManualEventModels.Document> {
    return this.http.delete<PanicManualEventModels.Document>(
      api.manualEvents.delete(id),
    );
  }

  public reorder(orderedIds: string[]): Observable<boolean> {
    return this.http.put<boolean>(api.manualEvents.reorder, { orderedIds });
  }
}
